'use strict';

module.exports = require('./Checkbox');


//////////////////
// WEBPACK FOOTER
// ./~/rc-checkbox/lib/index.js
// module id = 412
// module chunks = 0